var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"content-row",attrs:{"align-h":"center"}},[_c('b-col',[_c('div',{staticClass:"content-area"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }